import { createFileRoute } from '@tanstack/react-router'
import { SignUpPending } from '@/features/auth/signup-pending'

export const Route = createFileRoute('/(auth)/signup-pending')({
  component: SignUpPending,
})
